export class CurrentFeatureItem {
  featureName: string;
  item?: any;
  extraData?: any;
}
